type PropertyTitleSuggestionInput = {
  district?: string
  listingType?: string
  maxGuests?: number | string
  propertyType?: string
  furnished?: boolean
  bedrooms?: number | string
}

function toNumber(value: number | string | undefined) {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

function getPropertyTypeLabel(value: string | undefined) {
  switch (String(value || "").toUpperCase()) {
    case "APPARTEMENT":
      return "Appartement"
    case "RESIDENCE_MEUBLEE":
      return "Residence meublee"
    case "VILLA":
      return "Villa"
    case "STUDIO":
      return "Studio"
    case "IMMEUBLE":
      return "Immeuble"
    default:
      return "Bien immobilier"
  }
}

function getListingLabel(listingType: string | undefined, furnished: boolean) {
  const normalized = String(listingType || "").toUpperCase()
  if (normalized === "RENT") {
    return furnished ? "a louer" : "location"
  }
  if (normalized === "BOTH") {
    return "vente ou location"
  }
  return "a vendre"
}

export function suggestPropertyTitle({
  district,
  listingType,
  maxGuests,
  propertyType,
  furnished,
  bedrooms,
}: PropertyTitleSuggestionInput) {
  const typeLabel = getPropertyTypeLabel(propertyType)
  const districtLabel = String(district || "").trim()
  const rooms = toNumber(bedrooms)
  const guests = toNumber(maxGuests)

  const parts = [
    typeLabel,
    rooms > 0 ? `${rooms} chambre${rooms > 1 ? "s" : ""}` : "",
    districtLabel ? districtLabel : "",
    getListingLabel(listingType, Boolean(furnished)),
  ].filter(Boolean)

  let title = parts.join(" - ")

  if (guests > 0 && String(propertyType || "").toUpperCase() === "RESIDENCE_MEUBLEE") {
    title += ` - ${guests} voyageur${guests > 1 ? "s" : ""}`
  }

  return title
}
